import { useDispatch, useSelector } from "react-redux";
import useNotificationFilterHook from "../../hooks/useNotificationFilterHook";
import { Button } from "react-bootstrap";
import NotificationFilterUpdateButton from "./NotificationFilterUpdateButton";
import { notificationFilterConstants } from "../../constants";
import NotificationWorkspaceDropdown from "./NotificationWorkspaceDropdown";

function NotificationFilterButtonGroup({
    containerClassName = 'notifications--notification-list--filter-container',
}) {
    const dispatch = useDispatch();

    // Constants
    const filter_values = notificationFilterConstants.NOTIFICATION_FILTERS;

    // Redux
    const {
        view_comments,
        view_mentions,
        view_status,
        view_reminders,
        selected_filter
    } = useSelector(state => state.notification_filter);

    // Hooks
    useNotificationFilterHook();

    const getButtonVariant = (filter_name) => {
        if(filter_name === null && selectFilter === null) return 'orange';
        if(selected_filter === filter_name) return 'orange';
        return 'transparent-with-hover-border'
    }

    const selectFilter = (filter_name) => {
        dispatch({type: notificationFilterConstants.SELECT_NOTIFICATION_FILTER, payload: filter_name})
    }
    
    return (
        <>
            <div
                className={containerClassName}
            >
                <Button
                    variant={getButtonVariant(null)}
                    className='rounded-pill'
                    onClick={() => selectFilter(null)}
                >
                    All
                </Button>
                
                {
                    view_comments &&
                        <Button
                            variant={getButtonVariant(filter_values?.comments)}
                            className='rounded-pill'
                            onClick={() => selectFilter(filter_values?.comments)}
                        >
                            Comments
                        </Button>
                }

                {
                    view_mentions &&
                        <Button
                            variant={getButtonVariant(filter_values?.mentions)}
                            className='rounded-pill'
                            onClick={() => selectFilter(filter_values?.mentions)}
                        >
                            Mentions
                        </Button>
                }

                {
                    view_status &&
                        <Button
                            variant={getButtonVariant(filter_values?.status)}
                            className='rounded-pill'
                            onClick={() => selectFilter(filter_values?.status)}
                        >
                            Status
                        </Button>
                }

                {
                    view_reminders &&
                        <Button
                            variant={getButtonVariant(filter_values?.reminders)}
                            className='rounded-pill'
                            onClick={() => selectFilter(filter_values?.reminders)}
                        >
                            Reminders
                        </Button>
                }

                <NotificationFilterUpdateButton />
            </div>

            <NotificationWorkspaceDropdown />
        </>
    )

}

export default NotificationFilterButtonGroup;